import { NetworkFinancialstatmentPaymentRepository } from "./pbm/network-financial-statment-payment.repository";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { AuthRepository } from "./auth.repository";
import { ParserModule } from "./parsers/parser.module";
import { GatewayModule } from "../gateways/gateway.module";
import { UserRepository } from "./user.repository";
import { ResetPasswordRepository } from "./reset-password.repository";
import { HealthRepository } from "./health.repository";
import { NewsRepository } from "./news.repository";
import { BeneficiaryRepository } from "./pbm/beneficiary.repository";
import { CompanyRepository } from "./pbm/company.repository";
import { ProductRepository } from "./pbm/product.repository";
import { PaymentRepository } from "./pbm/payment.repository";
import { BenefitRepository } from "./pbm/benefit.repository";
import { NetworkRepository } from "./pbm/network.repository";
import { ProductCategoryRepository } from "./pbm/product-category.repository";
import { MedicalPrescriptionRepository } from "./pbm/medical-prescription.repository";
import { SalesHistoryRepository } from "./pbm/sales-history.repository";
import { TherapeuticClassRepository } from "./pbm/therapeutic-class.repository";
import { FinancialStatementRepository } from "./pbm/financial-statement.repository";
import { StateRepository } from "./pbm/state.repository";
import { FileExportRepository } from "./file-export.repository";
import { JobDescriptionRepository } from "./pbm/job-description.repository";
import { IndicatorRepository } from "./pbm/indicator.repository";
import { NetworkTermRepository } from "./pbm/network-term.repository";
import { IndustryRepository } from "./pbm/industry.repository";
import { ProductManagementRepository } from "./pbm/product-management.repository";
import { TransactionManagementRepository } from "./pbm/transaction-management.repository";
import { PractitionerManagementRepository } from "./pbm/practitioner-management.repository";
import { DrugstoreTestsRepository } from "./pbm/drugstore-tests.repository";
import { GeneralReportRepository } from "./pbm/general-report.repository";
import { ClustersRepository } from "./pbm/clusters.repository";
import { AuditSaleRepository } from "./pbm/audit-sale.repository";
import { TransactionLogRepository } from "./pbm/transaction-log.repository";
import { DeliveryPanelRepository } from "./pbm/delivery-panel.repository";
import { AuditSalePageableResultParser } from "./parsers/pbm/audit/audit-sale-pageable-result.parser";
import { UserTermRepository } from "./user-term.repository";

@NgModule({
  imports: [ParserModule.forRoot(), GatewayModule.forRoot()],
})
export class RepositoryModule {
  static forRoot(): ModuleWithProviders<RepositoryModule> {
    return {
      ngModule: RepositoryModule,
      providers: [
        AuthRepository,
        UserRepository,
        UserTermRepository,
        ResetPasswordRepository,
        HealthRepository,
        NewsRepository,
        BeneficiaryRepository,
        CompanyRepository,
        BenefitRepository,
        ProductRepository,
        TherapeuticClassRepository,
        NetworkRepository,
        NetworkFinancialstatmentPaymentRepository,
        ProductCategoryRepository,
        MedicalPrescriptionRepository,
        SalesHistoryRepository,
        FinancialStatementRepository,
        StateRepository,
        FileExportRepository,
        JobDescriptionRepository,
        IndicatorRepository,
        NetworkTermRepository,
        IndustryRepository,
        ProductManagementRepository,
        TransactionManagementRepository,
        PractitionerManagementRepository,
        DrugstoreTestsRepository,
        GeneralReportRepository,
        AuditSaleRepository,
        TransactionLogRepository,
        DeliveryPanelRepository,
        AuditSalePageableResultParser,
        ClustersRepository,
        PaymentRepository,
      ],
    };
  }
}
